import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/seo/SEO";

export default function NotFound() {
  return (
    <div className="pt-32 min-h-[80vh] flex flex-col items-center justify-center text-center px-6">
      <SEO
        title="Page Not Found"
        description="This channel isn't broadcasting right now. Head back to Your Channel Network to discover original series, movies, and live TV."
        noindex
      />
      <div className="font-display text-8xl font-black ycn-gradient-text">404</div>
      <p className="mt-4 text-white/60">This channel isn't broadcasting right now.</p>
      <Link to="/" className="ycn-btn-primary mt-6 px-6 py-3 rounded-full font-bold text-white transition-all">Back to YCN</Link>
    </div>
  );
}
